import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#B8A068] border-opacity-30" data-id="element-43">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B8A068] rounded-lg px-2" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-44">
        <span className="font-bold text-[#3D2E1F] text-xl pr-4" data-id="element-45">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-[#B8A068] transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-46" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out px-2 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-47">
        <p className="text-[#3D2E1F]" data-id="element-48">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito equipo especial?',
    answer: 'No, solo tu cama y tus propias manos.'
  }, {
    question: '¿Es seguro para la artritis?',
    answer: 'Sí, el método es de impacto cero y está diseñado para articulaciones sensibles.'
  }, {
    question: '¿Cuánto tiempo tarda en funcionar?',
    answer: 'Muchos sienten alivio en la movilidad desde la primera mañana, con beneficios acumulativos.'
  }, {
    question: '¿Es un libro físico?',
    answer: 'Es un producto digital (PDF) para acceso inmediato en tu celular o tableta.'
  }];
  return <section className="bg-[#FDF8F0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-10 text-center" data-id="element-51">
          Preguntas Frecuentes
        </h2>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-[#F5EDE0]" data-id="element-52">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-53" />)}
        </div>
      </div>
    </section>;
}